export default __webpack_public_path__ + "static/media/CloseFilled.98788ca8.svg";